"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author PKr
 */


var WindowSimulationUpdateDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowSimulationUpdateDTO, _DomainObject_1$Domai);

  function WindowSimulationUpdateDTO(windowId, windowTypeId, windowTypeNote, name, nameNote) {
    var _this;

    _classCallCheck(this, WindowSimulationUpdateDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowSimulationUpdateDTO).call(this));
    _this.windowId = windowId;
    _this.windowTypeId = windowTypeId;
    _this.windowTypeNote = windowTypeNote;
    _this.name = name;
    _this.nameNote = nameNote;
    return _this;
  }

  return WindowSimulationUpdateDTO;
}(DomainObject_1.DomainObject);

exports.WindowSimulationUpdateDTO = WindowSimulationUpdateDTO;